var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('JumpType',{attrs:{"options":_vm.mOptions},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }